import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

const mutateUpdateVendor = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${VENDORS}/${id}`, data);
};

const useUpdateVendorMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateVendor,
    ...queryParams,
  });

export default useUpdateVendorMutation;
